<template>
  <div class="app-layout">
    <!-- Sidebar debajo del navbar -->
    <div class="sidebar" :class="{ open: isSidebarOpen }">
      <div class="sidebar-content">
        <b-menu>
          <b-menu-list>
            <b-menu-item
              :active="$route.path === '/guests'"
              @click="navigateTo('/guests')"
              v-if="club.ModuloCertificado && $checkPermission('all-prospects')"
            >
              <template #label>
                <b-icon pack="fas" icon="user-friends" size="is-small" style="margin-right: 0.5em;"></b-icon>
                {{ i18n.guests[iso] }}
              </template>
            </b-menu-item>

            <b-menu-item
              :active="$route.path === '/new-member'"
              @click="navigateTo('/new-member')"
              v-if="$checkPermission('create-member') || $checkPermission('capturer')"
            >
              <template #label>
                <b-icon pack="fas" icon="user-plus" size="is-small" style="margin-right: 0.5em;"></b-icon>
                {{ i18n.newMember[iso] }}
              </template>
            </b-menu-item>

            <b-menu-item
              :active="$route.path === '/list-members'"
              @click="navigateTo('/list-members')"
              v-if="$checkPermission('cap-list-members') || $checkPermission('capturer')"
            >
              <template #label>
                <b-icon pack="fas" icon="users" size="is-small" style="margin-right: 0.5em;"></b-icon>
                {{ i18n.members[iso] }}
              </template>
            </b-menu-item>

            <b-menu-item
              :active="$route.path === '/financing-payments'"
              @click="navigateTo('/financing-payments')"
              v-if="club.ModuloFinanciamiento && $checkPermission('cap-financing-payments')"
            >
              <template #label>
                <b-icon pack="fas" icon="credit-card" size="is-small" style="margin-right: 0.5em;"></b-icon>
                {{ i18n.financingPayments[iso] }}
              </template>
            </b-menu-item>

            <b-menu-item
              :active="$route.path === '/weeks'"
              @click="navigateTo('/weeks')"
              v-if="club.ModuloSemanasInventario && $checkPermission('cap-view-weeks')"
            >
              <template #label>
                <b-icon pack="fas" icon="certificate" size="is-small" style="margin-right: 0.5em;"></b-icon>
                {{ i18n.certificates[iso] }}
              </template>
            </b-menu-item>
            <b-menu-item
              :active="$route.path === '/folios'"
              @click="navigateTo('/folios')"
              v-if="club.ModuloFolio && $checkPermission('cap-folios')"
            >
              <template #label>
                <b-icon pack="fas" icon="ticket-alt" size="is-small" style="margin-right: 0.5em;"></b-icon>
            {{ i18n.foliosMenu[iso] }}
              </template>
            </b-menu-item>
          </b-menu-list>

          <b-menu-list :label="i18n.club[iso] || 'Club'">
            <b-field>
              <b-select
                :value="club ? club.Id : null"
                @input="changeClubById"
                expanded
              >
                <option
                  v-for="c in sortedClubes"
                  :key="c.Id"
                  :value="c.Id"
                >
                  {{ c.Nombre }}
                </option>
              </b-select>
            </b-field>
          </b-menu-list>

          <b-menu-list :label="user">
            <b-menu-item
              @click="changeIso"
            >
              <template #label>
                <b-icon pack="fas" icon="globe" size="is-small" style="margin-right: 0.5em;"></b-icon>
                {{ i18n.language[iso] }}: {{ iso === 'es' ? i18n.spanish[iso] : i18n.english[iso] }}
              </template>
            </b-menu-item>

            <b-menu-item
              @click="exit"
            >
              <template #label>
                <b-icon pack="fas" icon="power-off" size="is-small" style="margin-right: 0.5em;"></b-icon>
                {{ i18n.logout[iso] }}
              </template>
            </b-menu-item>
          </b-menu-list>
        </b-menu>
      </div>
    </div>

    <!-- Navbar superior -->
    <b-navbar id="navbar-cap">
      <template #brand>
        <b-navbar-item tag="div" @click="isSidebarOpen = !isSidebarOpen" class="hamburger-btn">
          <b-icon pack="fas" icon="bars" size="is-medium"></b-icon>
        </b-navbar-item>
      </template>

      <template #start>
        <b-navbar-item class="navbar-logo-item">
          <img
            :src="club.Logo"
            alt="Logo"
            id="logo"
          />
        </b-navbar-item>
      </template>
    </b-navbar>

    <!-- Main Content -->
    <div class="main-content" :class="{ 'sidebar-open': isSidebarOpen }">
      <main class="h-full pb-16" style="background-color: #f6f5f2">
        <div class="container px-6" style="max-width: 1452px; padding-top: 20px">
          <router-view
            style="background: white; padding: 30px; margin: 30px 0"
          ></router-view>
        </div>
      </main>

      <footer class="footer" style="padding: 2rem 1.5rem 1.5rem">
        <div class="content has-text-centered">
          <p>
            © {{ `${club ? club.Nombre : ""}` }}, 2024.
            {{ i18n.allRightReserved[iso] }}.
          </p>
          <b-tag type=" is-link is-light"
            ><strong>{{ vCap }}</strong></b-tag
          >
        </div>
      </footer>
    </div>

    <b-modal v-model="ModalCert" :width="500" :can-cancel="['x']">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">
            {{ i18n.certificates__msg1[iso] }}
          </p>
          <button
            class="card-header-icon"
            aria-label="more options"
            @click="ModalCert = false"
          >
            <b-icon pack="fas" icon="times" type="is-danger"></b-icon>
          </button>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <!-- Club con ModuloFolio: solo Nombre/Apellido/Correo -->
            <template v-if="club.ModuloFolio">
              <div class="column is-12 has-text-weight-bold">
                <span>{{ i18n.foliosDisponibles[iso] }}: {{ foliosDisponibles }}</span>
              </div>
              <div class="column is-6">
                <b-field :label="i18n.name[iso]" label-position="on-border">
                  <b-input v-model="cert.Nombre" type="text" expanded :maxlength="30" :has-counter="true"></b-input>
                </b-field>
              </div>
              <div class="column is-6">
                <b-field :label="i18n.lastname[iso]" label-position="on-border">
                  <b-input v-model="cert.Apellido" type="text" expanded :maxlength="30" :has-counter="true"></b-input>
                </b-field>
              </div>
              <div class="column is-6">
                <b-field :label="i18n.email[iso]" label-position="on-border">
                  <b-input v-model="cert.Email" type="text" expanded :maxlength="100" :has-counter="true"></b-input>
                </b-field>
              </div>
              <div class="column is-6">
                <b-field :label="i18n.phone[iso]" label-position="on-border">
                  <b-input v-model="cert.Telefono" type="tel" icon-right="times" icon-pack="fas" icon-right-clickable @icon-right-click="cert.Telefono = null" expanded :maxlength="30" :has-counter="true"></b-input>
                </b-field>
              </div>
              <div class="column is-6">
                <b-field :label="i18n.catalogo[iso]" label-position="on-border">
                  <b-select v-model="cert.TipoCupon" expanded>
                    <option :value="'cruises'">{{ i18n.tipoCuponCruises[iso] }}</option>
                  </b-select>
                </b-field>
              </div>
            </template>
            <!-- Flujo actual (clubes sin módulo de folios) -->
            <template v-else>
            <div class="column is-6">
              <b-field :label="i18n.name[iso]" label-position="on-border">
                <b-input
                  v-model="cert.Nombre"
                  type="text"
                  icon-right="times"
                  icon-pack="fas"
                  icon-right-clickable
                  @icon-right-click="cert.Nombre = null"
                  expanded
                  :maxlength="30"
                  :has-counter="true"
                >
                </b-input>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="i18n.lastname[iso]" label-position="on-border">
                <b-input
                  v-model="cert.Apellido"
                  type="text"
                  icon-right="times"
                  icon-pack="fas"
                  icon-right-clickable
                  @icon-right-click="cert.Apellido = null"
                  expanded
                  :maxlength="30"
                  :has-counter="true"
                >
                </b-input>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="i18n.email[iso]" label-position="on-border">
                <b-input
                  v-model="cert.Email"
                  type="text"
                  icon-right="times"
                  icon-pack="fas"
                  icon-right-clickable
                  @icon-right-click="cert.Email = null"
                  expanded
                  :maxlength="100"
                  :has-counter="true"
                >
                </b-input>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="i18n.language[iso]" label-position="on-border">
                <b-select v-model="cert.Idioma" expanded>
                  <option :value="'EN'">
                    {{ i18n.english[iso] }}
                  </option>
                  <option :value="'SP'">
                    {{ i18n.spanish[iso] }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="i18n.type[iso]" label-position="on-border">
                <b-select v-model="cert.Tipo" expanded>
                  <option :value="'usa'">Usa</option>
                  <option :value="'international'">International</option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field :label="i18n.quantity[iso]" label-position="on-border">
                <b-select v-model="cert.Cantidad" expanded>
                  <option :value="1">1</option>
                  <option :value="2">2</option>
                  <option :value="3">3</option>
                </b-select>
              </b-field>
            </div>
            </template>
            <div class="column is-12 has-text-centered" v-if="errorCert">
              <span style="color: #f14668; font-weight: bold">{{
                errorCert
              }}</span>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <a
            class="card-footer-item"
            @click="createCertificate"
            v-if="!club.ModuloFolio || foliosDisponibles > 0"
          >
            <span style="color: #48c78e; font-weight: bold; font-size: 130%">{{
              i18n.save[iso]
            }}</span>
            <b-icon
              pack="fas"
              :icon="loadingCert ? 'sync-alt' : 'save'"
              type="is-success"
              :custom-class="loadingCert ? 'fa-spin' : ''"
            ></b-icon>
          </a>
          <a class="card-footer-item" @click="ModalCert = false" v-else>
            <span style="color: #f14668; font-weight: bold; font-size: 130%">{{
              i18n.foliosNoDisponibles[iso]
            }}</span>
          </a>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import i18n from "../../utils/i18n";
import axios from "axios";
const API_URL = process.env.VUE_APP_API_URL;

export default {
  data() {
    return {
      iso: "en",
      i18n,
      user: "",
      clubes: [],
      club: null,
      media: null,
      mediarecorder: null,
      vCap: process.env.VUE_APP_BUILD_VERSION || "dev",
      cert: {
        Nombre: null,
        Apellido: null,
        Email: null,
        Telefono: null,
        Idioma: "EN",
        Tipo: "usa",
        Cantidad: 1,
        TipoCupon: "cruises",
      },
      loadingCert: false,
      errorCert: false,
      ModalCert: false,
      foliosDisponibles: 0,
      role: null,
      isSidebarOpen: false,
    };
  },
  computed: {
    sortedClubes() {
      return [...this.clubes].sort((a, b) =>
        a.Nombre.localeCompare(b.Nombre)
      );
    },
  },
  async created() {
    let __iso = localStorage.getItem("iso");
    if (!__iso) {
      this.iso = "en";
      localStorage.setItem("iso", "en");
      this.$bus.emit("change-iso");
      this.$forceUpdate();
    } else {
      this.iso = __iso;
    }

    this.user = localStorage.getItem("user") || "";
    this.role = localStorage.getItem("role") || null;
    this.getClub();

    this.$bus.on("open-modal-cert", this.openModalCert);
  },
  beforeDestroy() {
    this.$bus.off("open-modal-cert", this.openModalCert);
  },
  methods: {
    navigateTo(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    insertIcon(img) {
      let link = null;
      link = document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = img;
      document.getElementsByTagName("head")[0].appendChild(link);
    },

    insertName(name) {
      let text = document.createTextNode(name);
      let title = document.createElement("title");
      title.appendChild(text);
      document.getElementsByTagName("head")[0].appendChild(title);
    },
    changeIso() {
      this.$buefy.dialog.confirm({
        message: this.i18n.changeIso[this.iso],
        type: "is-info",
        onConfirm: () => {
          if (localStorage.getItem("iso") === "es") {
            localStorage.setItem("iso", "en");
            this.iso = "en";
          } else {
            localStorage.setItem("iso", "es");
            this.iso = "es";
          }
          this.$bus.emit("change-iso");
        },
      });
    },
    exit() {
      localStorage.removeItem("user");
      localStorage.removeItem("role");
      localStorage.removeItem("userEmail");
      localStorage.removeItem("userId");
      localStorage.removeItem("clubes");
      localStorage.removeItem("club");
      localStorage.removeItem("permissions");
      this.$router.push("/logincap");
    },
    getClub() {
      let clubes = localStorage.getItem("clubes");
      clubes = clubes ? JSON.parse(clubes) : [];
      this.clubes = clubes;

      let club = localStorage.getItem("club");
      club = club ? JSON.parse(club) : {};
      this.club = club;

      this.insertIcon(club?.LogoIcon || "");
      this.insertName(club?.Nombre || "");

      this.$forceUpdate();
    },
    changeClub(club) {
      localStorage.setItem("club", JSON.stringify(club));
      this.$bus.emit("change-club");
      this.$router.go(0);
    },
    changeClubById(clubId) {
      const club = this.clubes.find((c) => c.Id === clubId);
      if (club) {
        this.changeClub(club);
      }
    },
    async reportBug(description) {
      const media = await navigator.mediaDevices.getDisplayMedia({
        video: { frameRate: { ideal: 30 } },
      });
      const mediarecorder = new MediaRecorder(media, {
        mimeType: "video/webm;codecs=vp8,opus",
      });
      mediarecorder.start();

      this.media = media;
      this.mediarecorder = mediarecorder;

      const [video] = media.getVideoTracks();
      video.addEventListener("ended", () => {
        mediarecorder.stop();
        this.media = null;
        this.mediarecorder = null;
      });

      mediarecorder.addEventListener("dataavailable", (e) => {
        const reader = new FileReader();
        reader.readAsDataURL(e.data);
        const __this = this;

        reader.onload = async function (e) {
          const club = localStorage.getItem("club");
          const user = localStorage.getItem("user");
          try {
            await axios.post(`${API_URL}/bugs/create`, {
              Plataforma: "cap",
              VersionPlataforma: this.vCap,
              ClubId: (club && JSON.parse(club)?.Id) || null,
              Descripcion: description,
              VideoBase64: reader?.result,
              ReportadoPor: user || null,
            });
          } catch (error) {
            console.log(error);
          }
          __this.$buefy.dialog.alert({
            title: __this.i18n.reportBug[__this.iso],
            message: __this.i18n.reportBug__msg6[__this.iso],
            type: "is-success",
            hasIcon: true,
            icon: "bug",
            iconPack: "fas",
            ariaRole: "alertdialog",
            ariaModal: true,
          });
        };
      });
    },
    stopRecordingBug() {
      if (this.media && this.mediarecorder) {
        const [video] = this.media.getVideoTracks();
        video.stop();
        this.mediarecorder.stop();
        this.media = null;
        this.mediarecorder = null;
      }
    },
    checkReportBug() {
      this.$buefy.dialog.confirm({
        title: this.i18n.reportBug[this.iso],
        message: this.i18n.reportBug__msg3[this.iso],
        confirmText: this.i18n.iUnderstand[this.iso],
        cancelText: this.i18n.cancel[this.iso],
        type: "is-info",
        icon: "video",
        iconPack: "fas",
        hasIcon: true,
        onConfirm: () => {
          this.$buefy.dialog.prompt({
            message: this.i18n.reportBug__msg4[this.iso],
            inputAttrs: {
              placeholder: this.i18n.reportBug__msg5[this.iso],
              maxlength: 100,
            },
            trapFocus: true,
            onConfirm: (value) => this.reportBug(value),
          });
        },
      });
    },

    async createCertificate() {
      try {
        this.loadingCert = true;
        let payload = {
          ...this.cert,
          ClubId: this.club.Id,
          CreadoPor: localStorage.getItem("user"),
        };
        if (this.club.ModuloFolio) {
          // Rama folios: solo Nombre/Apellido/Correo/Teléfono/Catálogo (1 folio = 1 cliente)
          payload = {
            Nombre: this.cert.Nombre,
            Apellido: this.cert.Apellido,
            Email: this.cert.Email,
            Telefono: this.cert.Telefono,
            TipoCupon: this.cert.TipoCupon || "cruises",
            ClubId: this.club.Id,
            CreadoPor: localStorage.getItem("user"),
          };
        }
        const { data } = await axios.post(`${API_URL}/cupones/create-from-folio`, payload);

        this.loadingCert = false;
        this.ModalCert = false;
        this.cert = {
          Nombre: null,
          Apellido: null,
          Email: null,
          Telefono: null,
          Idioma: "EN",
          TipoCupon: "cruises",
        };

        // Refrescar saldo tras consumir un folio
        if (this.club.ModuloFolio) {
          this.getFoliosDisponibles();
          this.$bus.emit("folios-balance-refresh");
        }

        this.$buefy.dialog.alert({
          message: this.i18n.certificates__msg2[this.iso],
          type: "is-success",
          hasIcon: true,
          icon: "check",
          iconPack: "fas",
          ariaRole: "alertdialog",
          ariaModal: true,
        });
      } catch (err) {
        console.log(err);
        this.loadingCert = false;
        const msg = err?.response?.data?.error || err?.response?.data?.message;
        console.log("msg", msg);
        this.errorCert = msg || this.i18n.certificates__msg3[this.iso];
      }
    },
    async getFoliosDisponibles() {
      try {
        const { data } = await axios.get(`${API_URL}/folios/balance`, {
          params: { ClubId: this.club.Id, CreadoPor: localStorage.getItem("user") },
        });
        this.foliosDisponibles = data.disponible;
      } catch (err) {
        console.log(err);
        this.foliosDisponibles = 0;
      }
    },
    openModalCert() {
      this.ModalCert = true;
      this.errorCert = false;
      if (this.club.ModuloFolio) {
        this.getFoliosDisponibles();
      }
    },
  },
};
</script>

<style scoped>
.app-layout {
  min-height: 100vh;
  position: relative;
}

#navbar-cap {
  position: sticky;
  top: 0;
  z-index: 40;
  box-shadow: -1px 7px 8px -3px rgba(0, 0, 0, 0.51);
  -webkit-box-shadow: -1px 7px 8px -3px rgba(0, 0, 0, 0.51);
  -moz-box-shadow: -1px 7px 8px -3px rgba(0, 0, 0, 0.51);
  height: 80px;
}

/* Sidebar debajo del navbar */
.sidebar {
  position: fixed;
  top: 80px;
  left: 0;
  bottom: 0;
  width: 260px;
  background-color: #fff;
  border-right: 1px solid #dbdbdb;
  transform: translateX(-100%);
  transition: transform 0.3s ease;
  z-index: 30;
  overflow-y: auto;
}

.sidebar.open {
  transform: translateX(0);
}

.sidebar-content {
  padding: 1.5rem;
}

.main-content {
  transition: margin-left 0.3s ease;
  margin-left: 0;
}

.main-content.sidebar-open {
  margin-left: 260px;
}

/* En móvil el sidebar se superpone y el contenido no se desplaza */
@media screen and (max-width: 1023px) {
  .main-content.sidebar-open {
    margin-left: 0;
  }
}

/* Centrar el logo en el navbar usando flexbox */
::v-deep #navbar-cap .navbar-start {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.navbar-logo-item {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 !important;
}

.navbar-logo-item img {
  max-height: 100%;
  width: auto;
  padding: 5%;
}

@media screen and (max-width: 1023px) {
  .navbar-logo-item {
    display: none !important;
  }
}

.hamburger-btn {
  cursor: pointer;
}

.pulsate-bck {
  animation: pulsate-bck 1.5s ease-in-out infinite both;
}

@keyframes pulsate-bck {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
}

#recording-screen .b-tooltip.is-danger .tooltip-content {
  margin-left: 40px;
}
</style>
